var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6886 7.0188C11.883 6.82267 11.8816 6.50609 11.6855 6.3117C11.4893 6.11731 11.1728 6.11872 10.9784 6.31486L9.8135 7.49017C9.34074 7.96716 9.01538 8.29437 8.73969 8.51577C8.4719 8.73083 8.29988 8.80461 8.14583 8.82425C8.0491 8.83658 7.95122 8.83658 7.85449 8.82425C7.70044 8.80461 7.52843 8.73083 7.26063 8.51577C6.98495 8.29437 6.65959 7.96716 6.18683 7.49017L5.02196 6.31486C4.82757 6.11873 4.51099 6.11731 4.31486 6.3117C4.11873 6.50609 4.11731 6.82267 4.3117 7.0188L5.49756 8.21529C5.94418 8.66593 6.30922 9.03426 6.63447 9.29546C6.97269 9.56708 7.31598 9.7637 7.72805 9.81622C7.90874 9.83925 8.09159 9.83925 8.27227 9.81622C8.68435 9.7637 9.02764 9.56708 9.36586 9.29546C9.6911 9.03426 10.0561 8.66595 10.5027 8.21531L11.6886 7.0188Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833496C4.04212 0.833496 0.833496 4.04212 0.833496 8.00016C0.833496 11.9582 4.04212 15.1668 8.00016 15.1668C11.9582 15.1668 15.1668 11.9582 15.1668 8.00016C15.1668 4.04212 11.9582 0.833496 8.00016 0.833496ZM1.8335 8.00016C1.8335 4.59441 4.59441 1.8335 8.00016 1.8335C11.4059 1.8335 14.1668 4.59441 14.1668 8.00016C14.1668 11.4059 11.4059 14.1668 8.00016 14.1668C4.59441 14.1668 1.8335 11.4059 1.8335 8.00016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowDown);
export default __webpack_public_path__ + "static/media/circle-arrow-down.13b252ea5d9795b643d37c00b4d313f6.svg";
export { ForwardRef as ReactComponent };